;(function ($) {
  "use strict"

  $.fn.createTabTrap = function (options) {
    const settings = $.extend(
      {
        closeElement: null, // Selector or jQuery object for the close element
      },
      options,
    )

    const $container = this
    let $focusableElements = $container
      .find(
        'a, button, input:not([type="hidden"]), textarea, select, details, [tabindex]:not([tabindex="-1"])',
      )
      .filter(":visible")

    const $closeElement = $(settings.closeElement)

    if ($closeElement.length) {
      const focusableArray = $focusableElements.toArray()
      focusableArray.push($closeElement[0])
      $focusableElements = $(focusableArray)
    }

    const $firstFocusableElement = $focusableElements.first()
    const $lastFocusableElement = $focusableElements.last()

    function handleTab(event) {
      if (event.key === "Tab") {
        if (event.shiftKey) {
          // Shift + Tab
          if (document.activeElement === $firstFocusableElement[0]) {
            event.preventDefault()
            $lastFocusableElement.focus()
          } else if (document.activeElement === $closeElement[0]) {
            event.preventDefault()
            $lastFocusableElement.focus()
          }
        } else {
          // Tab
          if (document.activeElement === $lastFocusableElement[0]) {
            event.preventDefault()
            $firstFocusableElement.focus()
          } else if (document.activeElement === $closeElement[0]) {
            event.preventDefault()
            $firstFocusableElement.focus()
          }
        }
      }
    }

    $container.on("keydown", handleTab)

    // Focus the first focusable element when the container is opened
    if ($firstFocusableElement.length) {
      $firstFocusableElement.focus()
    }

    // Return the container for chaining
    return $container
  }
})(jQuery)
